import axios from "axios";
import { adnPageSize } from "../components/common/GeneralConfigurations";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const messageStatisticUrl = `${baseApiUrl}/api/MessageStatistic`;

export async function getMessageStatistics(
  pageNumber = 1,
  pageSize = adnPageSize,
  orderBy = ""
) {
  return await httpRequest(
    fetchMessageStatistics.bind(this, pageNumber, pageSize, orderBy)
  );
}

async function fetchMessageStatistics(pageNumber, pageSize, orderBy) {
  let config = getHttpHeaders();
  return await axios.get(
    `${messageStatisticUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}`,
    config
  );
}

export async function getMessageStatisticById(id) {
  return await httpRequest(fetchMessageStatisticById.bind(this, id));
}

async function fetchMessageStatisticById(id) {
  let config = getHttpHeaders();
  return await axios.get(`${messageStatisticUrl}/${id}`, config);
}

export async function deleteMessageStatistic(id) {
  return await httpRequest(fetchDeleteMessageStatistic.bind(this, id));
}

async function fetchDeleteMessageStatistic(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${messageStatisticUrl}/${id}`, config);
}
